import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const SlideshowContainer = styled.div`
  position: relative;
  /* overflow: hidden; */
  padding-bottom: 56px;
  @media ${device.laptop} {
    padding-bottom: unset;
  }
`;

export const SlidesContainer = styled.div<{ offset: number; gapWidth?: number }>`
  display: flex;
  transform: translate3d(${({ offset }) => offset}px, 0px, 0px);
  transition: transform 0.5s ease;
  gap: ${(props) => (props.gapWidth ? `${props.gapWidth}px` : '32px')};
  backface-visibility: hidden;
`;

export const Slide = styled.div<{ cardWidth: number }>`
  flex: 0 0 ${(props) => (props.cardWidth ? `${props.cardWidth}px` : '718px')};
  height: unset;
  background-color: ${COLORS.white};
  @media ${device.laptop} {
    height: 360px;
    background-color: grey;
  }
`;

export const ContentContainer = styled.div<{ imgURL?: string }>`
  @media ${device.laptop} {
    height: 100%;
    background-image: url(${(props) => (props.imgURL ? props.imgURL : '')});
  }
`;

export const MobileImage = styled.img`
  width: 100%;
`;

export const DesktopImageContainer = styled.div<{ isCaMarket?: boolean }>`
  max-width: 373px;
  @media ${device.laptopMd} {
    max-width: 480px;
  }
  border-right: ${({ isCaMarket }) => !isCaMarket && `1px solid ${COLORS.grey15}`};
  border-bottom: ${({ isCaMarket }) => !isCaMarket && `1px solid ${COLORS.grey15}`};
  background-color: ${COLORS.white};
  position: relative;
`;

export const DesktopImage = styled.img<{ isActive?: boolean }>`
  width: 100%;
  height: 100%;
  max-width: 373px;
  object-fit: cover;
  object-position: center;
  @media ${device.laptop} {
    opacity: ${({ isActive }) => (isActive ? '1' : '50%')};
  }
  @media ${device.laptopL} {
    max-width: 475px;
  }
`;

export const DesktopTile = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: row;
  height: 100%;
  opacity: ${({ isActive }) => (isActive ? '1' : '50%')};
`;

export const MobileTile = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  opacity: ${({ isActive }) => (isActive ? '1' : '50%')};
  position: relative;
`;

export const OfferTypeWrapper = styled.div`
  position: absolute;
  top: 16px;
  left: 12px;
  @media ${device.laptop} {
    left: 20px;
  }
`;
